<template>
  <h1 class="d-flex justify-center align-center error--text">
    Define you own template in a child component extending this one
  </h1>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters: attendanceGettersMap, mapActions: attendanceActionsMap } = createNamespacedHelpers('attendance')

export default {
  name: 'BasePhase',
  props: {
    phaseKey: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...attendanceGettersMap(['getPhaseDataByKey', 'currentPhaseKey']),

    active() {
      return this.currentPhaseKey === this.phaseKey
    },
  },

  watch: {
    phaseData: {
      immediate: false,
      deep: true,
      handler(newVal, oldVal) {
        if (!oldVal) {
          /**
           * Previne que os dados sejam considerados como 'modificados' se for
           * apenas a primeira inicialização de phaseData, i.e. quando o campo
           * era null e passou a ser um objeto
           */
          return
        }

        this.setPhaseData({
          key: this.phaseKey,
          data: newVal,
        })
      },
    },
  },
  data() {
    return {
      /**
       * Dados da fase atual. É inicializado no mounted com os dados salvos
       * previamentes (store attendance) ou com o resultado de getDefaultData,
       * se não houver dados salvos previamente
       */
      phaseData: null,
    }
  },
  methods: {
    ...attendanceActionsMap(['setPhaseData']),
    /**
     * Método que recebe o model inicial 'zerado' a ser utilizado
     * para preenchimento dos dados da fase
     */
    getDefaultData() {
      throw new Error('You must implement getDefaultData method in your child component!')
    },
    /**
     * Método que pode ser implementado no filho para fazer qualquer modificação
     * ou verificação necessária após a inicialização de phaseData.
     */
    postPhaseDataLoaded() {
      return
    },
  },
  mounted() {
    const data = this.getPhaseDataByKey(this.phaseKey) || this.getDefaultData()
    if (data) {
      this.phaseData = {}
      Object.keys(data).forEach((key) => this.$set(this.phaseData, key, data[key]))
    }

    if (typeof this.phaseData !== 'object') {
      throw new Error('The implemented getDefaultData MUST return an object!')
    }

    requestAnimationFrame(() => requestAnimationFrame(() => this.postPhaseDataLoaded()))
  },
}
</script>
